import { motion } from 'framer-motion'

const TIERS = [
  { icon: '👑', amount: '£1,000', label: '1st place',       accent: 'gold',   ring: 'ring-2 ring-brand-gold/40' },
  { icon: '🥈', amount: '£500',   label: '2nd place',       accent: 'silver', ring: 'ring-1 ring-brand-silver/30' },
  { icon: '⭐', amount: '£250',   label: 'Best single post', accent: 'bronze', ring: 'ring-1 ring-brand-bronze/30' },
]

const ACCENT_BG = {
  gold:   'bg-gradient-to-br from-amber-50 to-yellow-50',
  silver: 'bg-gradient-to-br from-slate-50 to-zinc-50',
  bronze: 'bg-gradient-to-br from-orange-50 to-amber-50',
}

const ACCENT_TEXT = {
  gold:   'text-amber-900',
  silver: 'text-slate-700',
  bronze: 'text-orange-900',
}

/**
 * Prize pool visual for the dashboard sidebar. £1,750 split three ways:
 * 1st £1,000, 2nd £500, Best Single Post £250. Pulled from
 * lennon/management/linkedin-competition-q2-2026.md so this stays the
 * single source of truth in the UI.
 */
export default function PrizePool() {
  return (
    <div className="bg-white border border-brand-border rounded-xl p-5 shadow-card overflow-hidden relative">
      <div className="flex items-baseline justify-between mb-4">
        <h4 className="text-xs uppercase tracking-wider font-semibold text-brand-text-muted">Prizes</h4>
        <span className="text-xs text-brand-text-muted">Pays out August</span>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {TIERS.map((tier, i) => (
          <motion.div
            key={tier.label}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 + i * 0.08, duration: 0.35 }}
            className={`${ACCENT_BG[tier.accent]} ${tier.ring} rounded-lg p-2.5 text-center flex flex-col items-center gap-1`}
          >
            <span className="text-xl leading-none" aria-hidden="true">{tier.icon}</span>
            <span className={`text-sm font-bold ${ACCENT_TEXT[tier.accent]}`}>{tier.amount}</span>
            <span className="text-[10px] uppercase tracking-wider text-brand-text-muted leading-tight">
              {tier.label}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  )
}
